export default {
	state: {
		isOpened: false
	},
	getters: {},
	mutations: {},
	actions: {}
}